module.exports = __webpack_public_path__ + "generali.png?13be9fbbccfccf023fd762e5fce7c98b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/generali.png
// module id = 102
// module chunks = 0